module.exports = __webpack_public_path__ + "static/media/personal.b4570a11.png";